<template>
  <div class="nebCard"
    :style="cardStyle"
  >
    <div class="nebCard-imageWrapper"
      v-if="imageSrc !== '' || $slots.image"
    >
      <div class="nebCard-imageWrapper-content">
        <slot name="image">
          <div class="nebCard-image"
            :style="imageStyle"
          ></div>
        </slot>
        <div class="nebCard-imageWrapper-content-info"
          v-if="imageInfo"
        >
          <span>{{ imageInfo }}</span>
        </div>
      </div>

      <div class="nebCard-imageWrapper-overlay"
        v-if="$slots.imageOverlay"
      >
          <div class="nebCard-imageWrapper-overlay-content">
            <slot name="imageOverlay"></slot>
          </div>
      </div>
    </div>

    <div class="nebCard-bottomWrapper">
      <div class="nebCard-titleWrapper"
        v-if="title !== '' || $slots.title"
      >
        <div class="nebCard-titleWrapper-content">
          <slot name="title">
            <h3 class="nebCard-text"
              @click="onTitleClick"
              :class="{
                clickable: titleClickable
              }"
            >
              {{ truncatedTitle }}
            </h3>
          </slot>
        </div>
      </div>

      <div class="nebCard-contentWrapper"
        v-if="content !== '' || $slots.content"
      >
        <div class="nebCard-contentWrapper-content">
          <slot name="content">
            <p class="nebCard-text">{{ content }}</p>
          </slot>
        </div>
      </div>

      <div class="nebCard-footerWrapper"
        v-if="footer !== '' || $slots.footer"
      >
        <div class="nebCard-footerWrapper-content">
          <slot name="footer">
            <p class="nebCard-text">{{ footer }}</p>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NebCard',

  props: {
    imageSrc: {
      type: String,
      default: ''
    },
    imageTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    footer: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: 'initial'
    },
    /**
     * Enables pointer on title and emits an event when the title is clicked.
     */
    titleClickable: {
      type: Boolean,
      default: false
    },
    imageInfo: {
      type: String,
      default: ''
    }
  },

  computed: {
    cardStyle () {
      return {
        width: this.width,
        height: this.height
      }
    },
    imageStyle () {
      return {
        background: `url(${this.imageSrc}) no-repeat`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundOrigin: 'content-box',
        backgroundPosition: 'center',
        width: this.width !== '' ? this.width : '100%',
        height: '170px'
      }
    },
    truncatedTitle () {
      return this.title.length > 100 ? `${this.title.substring(0, 100)}...` : this.title
    }
  },

  methods: {
    onTitleClick () {
      if (this.titleClickable) {
        this.$emit('titleClicked')
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebCard {
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  border: solid 1px $warm-grey;
  background-color: $white;

  &-imageWrapper {
    border-bottom: solid 1px $warm-grey;
    position: relative;

    &-content {
      position: relative;

      &-info {
        position: absolute;
        right: 0;
        bottom: 0;
        background-color: black;
        padding: 5px 5px;

        span {
          color: #fff;
          font-size: 10px;
          font-family: $defaultFont;
        }
      }
    }

    &-overlay {
      box-sizing: border-box;
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      &-content {
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        width: 100%;
        height: 100%;
      }
    }
  }

  &-bottomWrapper {
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    flex-grow: 1;
  }

  &-imageWrapper,
  &-titleWrapper,
  &-contentWrapper,
  &-footerWrapper {
    box-sizing: border-box;
    overflow: hidden;
  }

  &-titleWrapper,
  &-contentWrapper,
  &-footerWrapper {
    padding: 10px;

    .nebCard-text {
      margin: 0;
    }
  }

  &-titleWrapper {
    .nebCard-text {
      font-family: $defaultFont;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $slate-grey;

      &.clickable {
        cursor: pointer;
      }
    }
  }

  &-contentWrapper,
  &-footerWrapper {
    .nebCard-text {
      font-family: $defaultFont;
      font-size: 12px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $slate-grey;
    }
  }
}
</style>
